module.exports = __webpack_public_path__ + "dc6b58b3383330763aa9e97937417182.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg2.jpg
// module id = 171
// module chunks = 1